import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { IMetricsService } from '@/services/Metrics/IMetricsService'

import { MetricsEventName } from '@/constants/metricsEvents'
import { PropertyObject } from '@/infra/MetricsProvider/IGenericMetricsProvider'

export const sendMetrics = (key: MetricsEventName, extra?: PropertyObject) => {
  const metricsService = InversionContainer.getInstance()
    .getContainer()
    .get<IMetricsService>(InjectionTokens.MetricsService)

  metricsService.sendMetric(key, extra)
}
